import axios from 'axios';
import { useQuery } from 'react-query';

import { WarriorNFT } from '~/../api/common.types';

export const useGetWarriors = () => {
  return useQuery<[WarriorNFT] | undefined, Error>(['warriors'], async () => {
    const { data: warriors } = await axios({
      url: '/api/warriors',
      method: 'get',
    });
    return warriors;
  });
};
